/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerListItemViewModel } from "../types/BannerListItemViewModel.ts";

export const bannerListItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do banner.")),
  title: z.string().describe("Título do banner.").nullish(),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa associada. Nulo para banners globais.")
    .nullish(),
  companyName: z
    .string()
    .describe("Nome da empresa associada. Nulo para banners globais.")
    .nullish(),
  startDate: z
    .string()
    .datetime()
    .describe("Data de início de exibição. Nulo significa sem restrição.")
    .nullish(),
  endDate: z
    .string()
    .datetime()
    .describe("Data de término de exibição. Nulo significa sem restrição.")
    .nullish(),
  general: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o banner é exibido para todos (geral) ou apenas para turmas vinculadas.",
      ),
  ),
  active: z.optional(z.boolean().describe("Indica se o banner está ativo.")),
  filePath: z
    .string()
    .describe(
      "URL pública da imagem ou vídeo principal do banner. Nulo quando nenhum arquivo foi enviado.",
    )
    .nullish(),
  filePathMobile: z
    .string()
    .describe(
      "URL pública da imagem ou vídeo mobile do banner. Nulo quando nenhum arquivo foi enviado.",
    )
    .nullish(),
}) as unknown as ToZod<BannerListItemViewModel>;
